// src/components/Footer.js
import React from 'react';

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} Boulder Video, LLC. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
